import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IOrderTemplateRepository } from '@/coreInfrastructureModule/interfaces/IOrderTemplateRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 発注テンプレートを削除するユースケース
 */
export class DeleteOrderTemplateUseCase {
  /**
   * コンストラクタ
   * @param repository - 発注テンプレートを削除するリポジトリ
   */
  constructor(private readonly repository: IOrderTemplateRepository) {}

  /**
   * テンプレートを削除する
   * @param templateId - テンプレートID
   */
  public Execute = async (templateId: string): Promise<INetworkResult<void, IError>> => {
    const result = await this.repository.delete(templateId);
    if (result.status.type === 'success') {
      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    }

    return { status: result.status };
  };
}
